export default __webpack_public_path__ + "static/media/opbeat.da68facb.svg";